// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content__wrapper{height:calc(100% - 58px)}.popup-session{z-index:999}.popup-session .bg-white{width:480px!important}.text--break{word-break:break-word;word-wrap:break-word}", ""]);
// Exports
module.exports = exports;
